import workspaceQuery from 'graphql/queries/product/SellingPriceMatrixPreviewWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/product/PriceMatrixPreviewQuery.graphql';
import fragment from 'graphql/fragments/customer/CustomerPriceMatrixPreviewFragment.graphql';

const CustomerPriceMatrixPreview = {
  type: 'PriceChange',
  title: 'Customer Price Matrix Preview',
  workspaceUrl: '/Sales/CustomerPricing/CustomerPriceMatrix/Preview/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'CUSTOMER_PRICE_MATRICES',
};

export default CustomerPriceMatrixPreview;
